module.exports = __webpack_public_path__ + "img/logo2.c167a242.png";